const smartzEventConst = {
  analysing: 'ANALYSING',
  padRemoved: 'DISCONNECTED',
  external: 'WETSURFACE',
  outOfRange: 'OUTOFRANGE',
  lowBattery: 'LOWBATTERY',
  timeToChange: 'PAD_CHANGE_ALERT', // deprecated
  fall: 'FALL_DETECTED_ALERT',
  reposition: 'POSITION_CHANGE_ALERT',
  temperature: 'TEMPERATURE_CHECK_ALERT',
  green: 'GREEN',
  yellow: 'YELLOW',
  red: 'RED',
  diaperNotSelected: 'PADNOTSELECTED',
  goalTimeExceed: 'PAD_CHECK_ALERT_GOAL',
  allowedTimeExceed: 'PAD_CHECK_ALERT_ALLOWED',
  safeTimeExceed: 'PAD_CHECK_ALERT_SAFE',
  diaperNotUsed: 'PADUNKNOWN',
  newBattery: 'NEWBATTERY',
  leakage: 'LEAKAGE',
  unstable: 'UNSTABLE'
}

const voidConst = {
  external: 'WETSURFACE',
  outOfRange: 'OUTOFRANGE',
  small: 'SMALL',
  medium: 'MEDIUM',
  large: 'LARGE',
  diaperNotSelected: 'PADNOTSELECTED',
  padStart: 'PADSTART',
  padEndLevel1: 'PADENDLEVEL1',
  padEndLevel2: 'PADENDLEVEL2',
  padEndLevel3: 'PADENDLEVEL3',
  padEndLevel4: 'PADENDLEVEL4',
  padEndLevel5: 'PADENDLEVEL5'
}

const padCycleStartType = {
  notStart: 0,
  isStart: 1
}

const padCycleEndType = {
  notCompleted: 0,
  isCompletedImmediate: 1,
  isCompleted: 2
}

export { smartzEventConst, voidConst, padCycleStartType, padCycleEndType }
